import { render, staticRenderFns } from "./CropFungicides.vue?vue&type=template&id=25ff46ad&"
import script from "./CropFungicides.vue?vue&type=script&lang=js&"
export * from "./CropFungicides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports